export const getMblShipmentNumberFromHbl = (shipmentNumber: string | undefined): string => {
  if (!shipmentNumber) return '';

  const [mblShipmentNumber] = shipmentNumber.split('-');
  return mblShipmentNumber;
};
